import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { CelumButtonModule } from '@celum/common-components/button';
import { CelumIcon } from '@celum/common-components/icon';

import { EmptyPage } from './components/empty-page';

@NgModule({
  imports: [TranslateModule, CommonModule, CelumIcon, CelumButtonModule, EmptyPage],
  declarations: [],
  exports: [EmptyPage, TranslateModule, CelumButtonModule]
})
export class CelumEmptyPageModule {}
